import React, { Component } from "react";
import { Checkbox } from "antd";

export class AccountStatusType extends Component {
  handleChangeAccountStatus = (value) => {
    const { onChange } = this.props;
    onChange(value);
  };

  render() {
    const { value, editable, typeOption } = this.props;
    return (
      <div className="account-status-type">
        <Checkbox
          disabled={!editable}
          onChange={() => this.handleChangeAccountStatus(0)}
          checked={value === 0}
        >
          Active
        </Checkbox>
        <Checkbox
          disabled={!editable || (typeOption === "create_new" ? true : false)}
          onChange={() => this.handleChangeAccountStatus(1)}
          checked={value === 1}
        >
          Inactive
        </Checkbox>
      </div>
    );
  }
}
